import { up } from 'styled-breakpoints';
import styled from 'styled-components';
import LeftIcon from '../../../assets/icons/back.svg';
import { H6 } from 'pfm-ui-components';
import { useRouter } from 'next/router';
import { pxToRem } from '../../../styles/utils';
import { useAppContext } from '../../../store';

interface BackButtonProps {
  title?: string;
  onBack?: Function;
  noPaddingHorizontal?: boolean;
}

export default function BackButton(props: BackButtonProps) {
  const { title, onBack, noPaddingHorizontal } = props;
  const router = useRouter();
  const { state, setState } = useAppContext();
  const inAppBackNavigation = () => {
    setState({ ...state, inAppBackPressed: true });
    // router.back();
  };
  return (
    <ContainerStyled noPaddingHorizontal={noPaddingHorizontal}>
      <BackButtonWrapper onClick={() => (onBack ? onBack() : inAppBackNavigation())} role="button">
        <ArrowIcon />
        {/* TODO Update Back arrow Icon based on design */}
        <StyledH6>{title || 'Back'}</StyledH6>
      </BackButtonWrapper>
    </ContainerStyled>
  );
}

const ContainerStyled = styled.div<{ noPaddingHorizontal?: boolean }>`
  display: flex;
  align-items: center;
  flex-grow: 1;
  position: relative;
  padding: ${(props) => (props.noPaddingHorizontal ? `${pxToRem(12)} 0` : `${pxToRem(12)} ${pxToRem(16)}`)};
  ${up('md')} {
    padding-left: 0px;
  }
`;

const BackButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  cursor: pointer;
  align-items: center;
`;

const ArrowIcon = styled(LeftIcon)`
  width: 20px;
  height: 20px;
  margin-right: 8px;

  ${up('md')} {
    width: 24px;
    height: 24px;
  }
`;

const StyledH6 = styled(H6)`
  font-weight: bold;
  color: ${(props) => props.theme.palette.black3};
`;
